// extracted by mini-css-extract-plugin
module.exports = {"user":"UserItem_user__3LDGG","userDetails":"UserItem_userDetails__2dRgV","name":"UserItem_name__22IHP","username":"UserItem_username__1vAig"};